import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { StyledCircularChip } from '@openx/components-core/lib/Chip/StyledChip.ts';
import { ValuePlaceholder } from '@openx/components-core/lib/Value/ValuePlaceholder/ValuePlaceholder.tsx';

export interface ParticipantNamesCellProps {
  names: string[];
}

/**
 * Renders participant names:
 * - Empty array → ValuePlaceholder
 * - Single name → wrapped text (no ellipsis)
 * - Multiple names → first name + StyledCircularChip with total count, Tooltip listing all names
 */
export function ParticipantNamesCell({ names }: ParticipantNamesCellProps) {
  if (!names.length) {
    return <ValuePlaceholder />;
  }

  if (names.length === 1) {
    return (
      <Box
        component="span"
        sx={{
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          display: 'block',
        }}
      >
        {names[0]}
      </Box>
    );
  }

  const tooltipTitle = (
    <Box component="span">
      {names.map((name, index) => (
        <Typography key={index} variant="body2">
          {name}
        </Typography>
      ))}
    </Box>
  );

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
      <Box
        component="span"
        sx={{
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          flexShrink: 1,
          minWidth: 0,
        }}
      >
        {names[0]}
      </Box>
      <Tooltip title={tooltipTitle}>
        <StyledCircularChip size="small" data-test="deal-participants-count-chip" label={names.length} />
      </Tooltip>
    </Box>
  );
}
